import React from "react";
import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NorthEastIcon from "@mui/icons-material/OpenInFullOutlined";
import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import BedIcon from "@mui/icons-material/Bed";

const AmberSuitesDetail = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const styles = {
        container: {
            maxWidth: "100%",
            width: isMobile ? "90%" : "80%",
            height: "auto",
            padding: "20px",
        },
        heading: {
            fontFamily: "ZapfHumnst BT",
            fontSize: {
                xs: "16px",
                sm: "20px",
                md: "20px",
                lg: "22px",
                xl: "24px",
            },
            lineHeight: "39.71px",
            letterSpacing: "0.05em",
            textAlign: "left",
            color: "#181818",
            margin: 0,
            position: "relative",
        },
        underline: {
            position: "absolute",
            bottom: -5,
            left: 0,
            width: "100%",
            height: "2px",
            backgroundColor: "#E4CAAE",
        },
        gridContainer: {
            display: "grid",
            gridTemplateColumns: isMobile ? "0.8fr 1fr" : "1.45fr 1fr", // Two columns
            gap: "20px",
            marginTop: "20px",
            paddingLeft: "0",
        },
        section: {
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            height: "auto",
            marginLeft: "-20px", 
        },
        subheading: {
            fontFamily: "ZapfHumnst BT",
            fontSize: {
                xs: "14px",
                sm: "16px",
                md: "16px",
                lg: "18px",
                xl: "20px",
            },
            fontWeight: 400,
            lineHeight: "24.76px",
            letterSpacing: "0.05em",
            textAlign: "left",
            color: "#886F58",
            display: "flex",
            alignItems: "center",
        },
        icon: {
            marginRight: "10px",
            fontSize: {
                xs: "14px",
                sm: "16px",
                md: "16px",
                lg: "18px",
                xl: "20px",
            },
        },
        description: {
            fontFamily: "Sora",
            fontSize: {
                xs: "14px",
                sm: "16px",
                md: "16px",
                lg: "18px",
                xl: "20px",
            },
            fontWeight: 400,
            lineHeight: "25.2px",
            textAlign: "left",
            marginTop: "10px",
            color: "#4D4D4D",
        },
    };

    const suiteDetails = [
        { icon: <NorthEastIcon sx={styles.icon} />, heading: "Area", description: "2000 sq ft" },
        { icon: <PeopleIcon sx={styles.icon} />, heading: "Occupancy", description: "2 adults (max 4 guests)" },
        { icon: <BedIcon sx={styles.icon} />, heading: "Beds", description: "A king-size bed" },
        { icon: <RestaurantIcon sx={styles.icon} />, heading: "Meal", description: "Lunch, snacks, dinner, breakfast " },
    ];

    return (
        <Box sx={styles.container}>
            <Typography sx={styles.heading}>
                SUITE DETAILS
                <Box sx={styles.underline} />
            </Typography>

            <Box sx={styles.gridContainer}>
                {suiteDetails.map((detail, index) => (
                    <Box key={index} sx={styles.section}>
                        <Typography sx={styles.subheading}>
                            {detail.icon} {detail.heading}
                        </Typography>
                        <Typography sx={styles.description}>
                            {detail.description}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default AmberSuitesDetail;
